import React from 'react';
import { withStyles } from 'material-ui';
import { translate } from 'react-i18next';
import DynIcon from '../Utils/DynIcon';

const styles = theme => ({
    facilityItem: {
        float: 'left',
        display: 'contents',
        paddingRight: '5px',
        color: 'var(--primary-color)'
    }
});

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};


function getFacilityName(facility, lang) {
    return ' ' + (facility['description_' + lang] || facility.description);
}

class HotelFacilitiesRender extends React.Component {
    render() {
        const { hotel, language, classes } = this.props;
        return (
            <div className="services">
                    <ul>
                        {
                            hotel.facilities.slice(0, 9).map((service, idx) => {
                                return (
                                    <li>
                                        <div className={classes.facilityItem}>
                                            <DynIcon icon={service.group} style={{ color: 'inherit' }} />
                                        </div>
                                        {getFacilityName(service, language)}
                                    </li>
                                );
                            })
                        }
                        {
                            hotel.facilities.slice(9).map((service, idx) => {
                                return (
                                    <li>
                                        <div className={classes.facilityItem}>
                                            <DynIcon icon={service.group} style={{ color: 'inherit' }} />
                                        </div>
                                        {getFacilityName(service, language)}
                                    </li>
                                );
                            })
                        }
                    </ul>
            </div>
        );
    }
}
export default translate('translations')(withStyles(styles)(HotelFacilitiesRender));


// WEBPACK FOOTER //
// ./src/components/Reservation/HotelFacilitiesRender.js